import angular from 'angular';
import fundingAvailable from './fundingAvailable';

export default angular
  .module('fundingDetailsSection.scenes.fundingAvailable', [])
  .component('fundingAvailable', fundingAvailable).name;
